import { ThemeProvider } from '@material-ui/core/styles';
import { createP44Theme } from '../../utils/theme';

export default function P44ThemeProvider(props: { children: React.ReactNode }) {
  return (
    <ThemeProvider theme={createP44Theme()}>{props.children}</ThemeProvider>
  );
}
